<template>
    <div>
        <div v-if="groups.length > 0" class="row">
            <div class="col-md-3">
                <div class="mb-4">
                    <GroupFilterSelect
                        :groups="groups"
                        @group-changed="handleGroupChange"
                    />
                </div>
            </div>
        </div>
        <table class="table table-bordered table-striped table-vcenter dataTable" style="width: 100%;">
            <thead>
                <tr>
                    <th v-if="!this.hide.includes('username')">Username</th>
                    <th v-if="!this.hide.includes('group')">Group</th>
                    <th v-if="!this.hide.includes('email')">Email</th>
                    <th v-if="!this.hide.includes('shadow')">Shadow</th>
                    <th v-if="!this.hide.includes('actions')">Actions</th>
                </tr>
            </thead>
            <tbody></tbody>
        </table>
    </div>
</template>

<script>

    import { buildColumns } from "@/helpers/build-columns";
    import GroupFilterSelect from "@/components/movements/users/GroupFilterSelect.vue";

    export default {
        components: {
            GroupFilterSelect
        },

        props: {
            ajaxUrl: {
                type: String,
                required: true,
            },
            groups: {
                type: Array,
                default: () => [],
                required: false,
            },
            hide: {
                type: Array,
                default: () => [],
                required: false
            },
        },

        data() {
            return {
                selectedGroup: null,
                columnDefinitions: {
                    username: {
                        data: 'username',
                        render: function (data, type, row) {
                            return row.computed_username;
                        }
                    },
                    email: {
                        data: 'email',
                        render: function (data, type, row) {
                            return row.computed_email;
                        }
                    },
                    group: {
                        data: 'group_id',
                        orderable: false,
                        searchable: false,
                        render: function (data, type, row) {
                            return row.computed_group;
                        }
                    },
                    shadow: {
                        data: 'shadow',
                        searchable: false,
                        orderable: false,
                        width: '200px',
                    },
                    actions: {
                        data: 'actions',
                        searchable: false,
                        orderable: false,
                        width: '200px',
                    }
                }
            }
        },

        mounted() {
            const table = window.jQuery(this.$el.querySelector('table'))
                .on('preXhr.dt', (e, settings, data) => {
                    data.selectedGroup = this.selectedGroup ? this.selectedGroup.id : null;
                })
                .DataTable({
                    processing: true,
                    serverSide: true,
                    pageLength: 25,
                    lengthMenu: [25, 50, 100],
                    ajax: {
                        url: this.ajaxUrl,
                    },
                    order: [[0, 'asc']],
                    columns: buildColumns(this.columnDefinitions, this.hide),
                });

            this.$watch(
                'selectedGroup',
                () => table.ajax.reload(null, false),
                {
                    deep: true
                }
            );
        },

        methods: {
            handleGroupChange(group) {
                this.selectedGroup = group;
            },
        },
    };
</script>
